import { useContext } from 'react';
import { AdminThemeContext } from '../theme/AdminThemeContext';
import { FormSurfaceContext } from '../theme/FormSurfaceContext';

export const useIsAdminSurface = () => {
  const adminTheme = useContext(AdminThemeContext);
  const isFormSurface = useContext(FormSurfaceContext);
  return adminTheme !== null && !isFormSurface;
};
